import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import moment from "moment";
import { Divider, Link, useMediaQuery, withStyles } from "@material-ui/core";
import LaunchOutlinedIcon from "@material-ui/icons/LaunchOutlined";
import EditIcon from "@material-ui/icons/Edit";
import OpenInNewRoundedIcon from "@material-ui/icons/OpenInNewRounded";
import editIcon from "../../assets/images/edit.png";

import StudentHistoryPopup from "../Glimpse/StudentHistoryPopup";
import bookIcon from "../../assets/images/book.svg";
import userIcon from "../../assets/images/students.svg";
import notesIcon from "../../assets/images/notes.svg";
import JoinNowBtn from "./JoinNowbtn/JoinNowBtn";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowOutwardIcon from "@material-ui/icons/CallMade";
import RescheduleFlow from "../MentorEditAndReschedule/RescheduleFlow";
import CancelFlow from "../MentorEditAndReschedule/CancelFlow";
import MentorEditAndReschedule from "../MentorEditAndReschedule";
import { getUserId } from "../../utils/auth";
import InfoIcon from "@mui/icons-material/Info";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { API } from "../../Services/api-services";
import { toast } from "react-toastify";
import swal from "sweetalert";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: "275px",
    marginBottom: "16px",
    boxShadow: "0px 1px 2px 0px #FBE2C6",
  },
  timeCls: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
    },
    background: "#F7ECDE",
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontSize: "20px",
    fontWeight: "500",
    lineHeight: "23.44px",
    textAlign: "center",
    padding: "8px 10px",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      fontSize: "13px",
    },
    fontStyle: "normal",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "16.41px",
    padding: "8px 5px",
    borderRadius: "2px",
    textAlign: "center",
  },
  demoTitle: {
    background: "linear-gradient(100.05deg, #F7DAA1 0%, #F4E378 100%)",
    color: "#8C5E03",
  },
  classTitle: {
    background: "linear-gradient(100.05deg, #F8C9AB 0%, #F9DDBD 100%)",
    color: "#A35700",
  },
  parentDiv: {
    display: "flex",
    background: "#FBF5EE",
    border: "1px solid #F7ECDE",
    borderRadius: "4px",
    padding: "10px 10px !important",
  },
  timeAndClassDetails: {
    maxWidth: "75px",
  },
  classDetails: {
    marginLeft: "20px",
    width: "calc(100% - 95px)",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  middleComponent: {
    display: "flex",
    justifyContent: "space-between",
    position: "relative",
  },
  middleTxt: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "10px",
    },
  },
  txt: {
    color: "#666666",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "16.41px",
    textAlign: "left",
    marginBottom: "10px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  studentNameCls: {
    textDecoration: "underline",
    cursor: "pointer",
  },
  italicTxt: {
    fontStyle: "italic",
  },
  twoLineTruncate: {
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
  },
  sessionDetailsicon: {
    margin: "-2px 4px 0 0px",
    height: "17px",
    width: "17px",
  },
  courseTxt: {
    color: "#3D3D3D",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "16.41px",
    marginBottom: "10px",
  },
  icon: {
    color: "#666666",
  },
  BtnCls: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "16.94px",
    textAlign: "left",
    textTransform: "none",
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    [theme.breakpoints.down("sm")]: {
      gap: "4px",
    }
    // marginTop: "-20px",
  },
  statusText: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "100%",
    color: "#FF0000",
    [theme.breakpoints.down("sm")]: {
      fontSize: "11px",
      lineHeight: "16px",
    },
  },
  statusIcon: {
    color: "#FF0000",
    [theme.breakpoints.down("sm")]: {
      width: "14px",
      height: "14px",
    },
  },
  editButtonContainer: {
    marginTop: "10px",
    display: "flex",
    gap: "8px",
  },
  editButtonMobile: {
    textTransform: "none",
    color: "#666",
    border: "none",
    fontSize: "14px",
    marginLeft: "-8px",
  },
  editButtonDesktop: {
    marginLeft: "8px",
    textTransform: "none",
    color: "#666",
    border: "none",
    fontSize: "14px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    }
  },
  editIcon: {
    height: "16px",
    width: "16px",
    objectFit: "contain",
    marginLeft: "4px",
    marginTop: "-2px",
  },
  joinActions: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "4px",
  },
  addGlimpseBtn: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "16.41px",
    textTransform: "none",
    color: "#666666",
  },
}));

const parseSessionTime = (timeStr) => {
  if (!timeStr) return null;
  const parsed = moment(
    timeStr,
    ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD hh:mm:ss A"],
    true,
  );
  if (parsed.isValid()) {
    return parsed;
  }
  const fallback = moment(timeStr);
  return fallback.isValid() ? fallback : null;
};

const UpcomingSessionCard = ({
  session,
  historyData,
  index,
  setHitUpcomingSessionsAPI,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const isDemo = session.isDemo;
  const isMobile = useMediaQuery("(max-width:600px)");
  const userId = getUserId();

  const classStartMoment = useMemo(
    () => parseSessionTime(session?.sessionIndiaStartTime),
    [session?.sessionIndiaStartTime],
  );
  const classEndMoment = useMemo(
    () => parseSessionTime(session?.sessionIndiaEndTime),
    [session?.sessionIndiaEndTime],
  );

  const startTime = classStartMoment ? classStartMoment.format("LT") : "-";

  const isWithinClassDuration = useMemo(() => {
    if (!classStartMoment || !classEndMoment) return false;
    const now = moment();
    return now.isSameOrAfter(classStartMoment) && now.isBefore(classEndMoment);
  }, [classStartMoment, classEndMoment]);

  const shouldShowAddGlimpse =
    !isDemo && !session?.glimpseExist && isWithinClassDuration;

  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [studentId, setStudentId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [showToolTipText, setShowToolTipText] = useState(false);
  const [sprDataList, setSprDataList] = useState({
    batchId: null,
    courseId: "",
  });
  const [showRescheduleFlow, setShowRescheduleFlow] = useState(false);
  const [showCancelFlow, setShowCancelFlow] = useState(false);
  const [editRescheduleOpen, setEditRescheduleOpen] = useState(false);
  const [hasMentorRequest, setHasMentorRequest] = useState(false);

  const handleEditRescheduleClose = () => {
    setEditRescheduleOpen(false);
    setHitUpcomingSessionsAPI((prev) => !prev);
  };

  const [isGlimpseLoading, setIsGlimpseLoading] = useState(false);

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#FFFFFF",
      color: "#666666",
      fontSize: "14px",
      maxWidth: "600px",
    },
  }))(Tooltip);

  useEffect(() => {
    if (session && session.studentDetails) {
      const updatedSprDataList = session.studentDetails.map((student) => ({
        batchId: session.batchId || "",
        courseId: session.courseId || "",
      }));
      setSprDataList(updatedSprDataList);
      setHasMentorRequest(session.hasMentorRequest || false);
    }
  }, [session]);

  const viewSPRHandler = (index) => {
    if (sprDataList[index] && sprDataList[index].batchId) {
      let sprData = { ...sprDataList[index] };
      if (sprData.batchId.endsWith(" ")) {
        sprData.batchId = sprData.batchId.slice(0, -1);
        sprData.batchId += "%20";
      }
      const studentId = session.studentDetails[index].studentId;
      window.open(
        `${process.env.REACT_APP_SPR}/${studentId}/${sprData.batchId}/${sprData.courseId}`,
      );
    }
  };

  const handleOpenInNewTab = (link) => {
    window.open(link, "_blank");
  };

  const handleAddGlimpse = async (scheduleId) => {
    setIsGlimpseLoading(true);
    try {
      const res = await API.post("/glimpse/backfill/single", {
        scheduleId,
        isManual: 1,
      });
      if (res?.data?.classInfoId) {
        history.push(`/mentor-feedback/${res.data.classInfoId}`);
      } else {
        swal(
          res.data.msg || res.data.message || "Failed to create glimpse entry!",
          {
            icon: "warning",
          },
        );
      }
    } catch (error) {
      console.error("Error adding glimpse:", error);
      swal(
        error.response?.data?.msg ||
          error.response?.data?.message ||
          "Failed to create glimpse entry!",
        {
          icon: "warning",
        },
      );
    } finally {
      setIsGlimpseLoading(false);
    }
  };

  const handleFeedbackClick = () => {
    setStudentId(session.studentDetails[0].studentId);
    setCourseId(session.courseId);
    setShowFeedbackPopup(true);
  };

  const closeFeedbackPopup = () => {
    setShowFeedbackPopup(false);
  };

  const handleEditClass = () => {
    setEditRescheduleOpen(true);
  };

  const handleCancelRequest = async () => {
    const confirm = await swal({
      title: "Cancel Request",
      text: "Are you sure you want to cancel this request?",
      icon: "warning",
      buttons: ["No", "Yes, Cancel"],
      dangerMode: true,
    });

    if (!confirm) return;

    try {
      await API.put(`/mentor/cancel/${session?.reqId}`, { mentorId: userId });
      toast.success("Request cancelled successfully!");
      setHasMentorRequest(false);
    } catch (error) {
      toast.error(
        error.response?.data?.msg ||
          error.response?.data?.message ||
          "Failed to cancel request!",
      );
    }
  };

  const handleCloseReschedule = () => {
    setShowRescheduleFlow(false);
  };

  const handleSwitchToCancel = () => {
    setShowRescheduleFlow(false);
    setShowCancelFlow(true);
  };

  const handleCloseCancel = () => {
    setShowCancelFlow(false);
  };

  const handleSwitchToReschedule = () => {
    setShowCancelFlow(false);
    setShowRescheduleFlow(true);
  };

  const handleToolTipTxtClick = (e) => {
    e.stopPropagation();
    setShowToolTipText((prev) => !prev);
  };

  const openStudentInfo = (student) => {
    if (!isReactNative()) {
      const baseUrl = process.env.REACT_APP_EPICENTER_URL;
      const url = `${baseUrl}#/student-manage/?studentId=${student.studentId}`;
      window.open(url, "_blank");
    }
  };

  const isReactNative = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    if (
      userAgent.includes("wv") ||
      userAgent.includes("react-native") ||
      window.ReactNativeWebView !== undefined
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent className={classes.parentDiv}>
        <div className={classes.timeAndClassDetails}>
          <Typography className={classes.timeCls}>{startTime}</Typography>
          <Typography
            className={`${classes.title} ${
              isDemo ? classes.demoTitle : classes.classTitle
            }`}
          >
            {isDemo ? `Demo` : `Class ${session.classNo}`}
          </Typography>
        </div>
        <div className={classes.classDetails}>
          <div className={classes.middleComponent}>
            <div className={classes.middleTxt}>
              <Typography className={classes.courseTxt}>
                {session.courseName}
              </Typography>
              {!isDemo && (
                <>
                  {isMobile ? (
                    <LightTooltip
                      title={session.batchName}
                      leaveDelay={500}
                      open={showToolTipText}
                      onClose={() => setShowToolTipText(false)}
                    >
                      <Typography
                        className={classes.txt}
                        onClick={handleToolTipTxtClick}
                      >
                        <img
                          src={bookIcon}
                          className={classes.sessionDetailsicon}
                          alt="book"
                        />{" "}
                        {session.batchName.length > 30
                          ? `${session.batchName.substring(0, 30)}...`
                          : session.batchName}
                      </Typography>
                    </LightTooltip>
                  ) : (
                    <Typography
                      className={classes.txt}
                      title={session.batchName}
                    >
                      <img
                        src={bookIcon}
                        className={classes.sessionDetailsicon}
                        alt="book"
                      />{" "}
                      {session.batchName}
                    </Typography>
                  )}
                </>
              )}
            </div>
            {!isMobile && (
              <div style={{ position: "absolute", right: 0, top: 0 }}>
                {hasMentorRequest ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "8px",
                    }}
                  >
                    <div className={classes.statusContainer}>
                      <InfoIcon className={classes.statusIcon} />
                      <div className={classes.statusText}>
                        {session.statusText}
                      </div>
                    </div>
                    {session?.reschedule && (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleCancelRequest}
                        className={classes.editButtonDesktop}
                      >
                        Cancel Request
                      </Button>
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    <JoinNowBtn
                      // isDisable={moment().isAfter(
                      //   moment(session.sessionIndiaStartTime).add(60, "minutes")
                      // )}
                      link={session}
                      dataComeFrom="classForTodayTable"
                      batch={session.batchName}
                      instructions={session.instructions}
                      index={index}
                    />

                    {!isDemo && !shouldShowAddGlimpse && (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleEditClass}
                        className={classes.editButtonDesktop}
                      >
                        Edit Class
                        <img
                          src={editIcon}
                          alt="edit"
                          className={classes.editIcon}
                        />
                      </Button>
                    )}

                    {shouldShowAddGlimpse && (
                      <Button
                        className={classes.addGlimpseBtn}
                        startIcon={
                          <AddCircleOutlineIcon style={{ fontSize: "18px" }} />
                        }
                        onClick={() => handleAddGlimpse(session.scheduleId)}
                        disabled={isGlimpseLoading}
                      >
                        {isGlimpseLoading ? "loading..." : "Add Glimpse"}
                      </Button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div>
            <div style={{ marginTop: "10px" }}>
              {isDemo && session.studentName && session.studentName.length > 0
                ? session.studentName.map((name, index) => (
                    <Typography key={index} className={classes.txt}>
                      <img
                        src={userIcon}
                        className={classes.sessionDetailsicon}
                        alt="users"
                      />{" "}
                      {name}
                    </Typography>
                  ))
                : session.studentDetails?.map((student, index) => (
                    <Typography
                      key={index}
                      className={`${classes.txt} ${classes.studentNameCls}`}
                      onClick={() => openStudentInfo(student)}
                    >
                      <img
                        src={userIcon}
                        className={classes.sessionDetailsicon}
                        alt="users"
                      />{" "}
                      {student.studentName}{" "}
                      {!isReactNative() && (
                        <ArrowOutwardIcon
                          style={{ fontSize: "14", cursor: "pointer" }}
                        />
                      )}
                    </Typography>
                  ))}
              {session.instructions && (
                <>
                  {isMobile ? (
                    session.instructions.length > 60 ? (
                      <LightTooltip
                        title={session.instructions}
                        open={showToolTipText}
                        onClose={() => setShowToolTipText(false)}
                      >
                        <Typography
                          className={`${classes.txt} ${classes.twoLineTruncate} ${classes.italicTxt}`}
                          onClick={handleToolTipTxtClick}
                        >
                          <img
                            src={notesIcon}
                            className={classes.sessionDetailsicon}
                            alt="notes"
                          />{" "}
                          {session.instructions}
                        </Typography>
                      </LightTooltip>
                    ) : (
                      <Typography
                        className={`${classes.txt} ${classes.twoLineTruncate} ${classes.italicTxt}`}
                      >
                        <img
                          src={notesIcon}
                          className={classes.sessionDetailsicon}
                          alt="notes"
                        />{" "}
                        {session.instructions}
                      </Typography>
                    )
                  ) : session.instructions.length > 180 ? (
                    <LightTooltip
                      title={session.instructions}
                      leaveDelay={500}
                      interactive
                      classes={{ tooltip: classes.tooltip }}
                    >
                      <Typography
                        className={`${classes.txt} ${classes.italicTxt}`}
                        style={{ width: "80%" }}
                      >
                        <img
                          src={notesIcon}
                          className={classes.sessionDetailsicon}
                          alt="notes"
                        />{" "}
                        {session.instructions}
                      </Typography>
                    </LightTooltip>
                  ) : (
                    <Typography
                      className={`${classes.txt} ${classes.italicTxt}`}
                    >
                      <img
                        src={notesIcon}
                        className={classes.sessionDetailsicon}
                        alt="notes"
                      />{" "}
                      {session.instructions}
                    </Typography>
                  )}
                </>
              )}
            </div>
            {isMobile && hasMentorRequest ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: "4px",
                  marginTop: "10px",
                }}
              >
                <div className={classes.statusContainer}>
                  <InfoIcon
                    className={classes.statusIcon}
                    style={{ height: "14px", width: "14px" }}
                  />
                  <div className={classes.statusText}>{session.statusText}</div>
                </div>
                {session?.reschedule && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelRequest}
                    className={classes.editButtonDesktop}
                  >
                    Cancel Request
                  </Button>
                )}
              </div>
            ) : isMobile ? (
              <div className={classes.editButtonContainer}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleEditClass}
                  className={classes.editButtonMobile}
                >
                  Edit Class
                  <img src={editIcon} alt="edit" className={classes.editIcon} />
                </Button>
              </div>
            ) : null}
            {!isMobile && (
              <>
                <Divider
                  style={{
                    color: "#F0D8BC",
                    marginTop: "10px",
                  }}
                />
                <div>
                  {session.lessonData && (
                    <Button
                      className={classes.BtnCls}
                      startIcon={
                        <LaunchOutlinedIcon
                          className={classes.icon}
                          fontSize="medium"
                        />
                      }
                    >
                      Lesson Plan
                    </Button>
                  )}
                  {session.visualAid && (
                    <Button
                      className={classes.BtnCls}
                      startIcon={
                        <LaunchOutlinedIcon
                          className={classes.icon}
                          fontSize="medium"
                        />
                      }
                      onClick={() => handleOpenInNewTab(session?.visualAid)}
                    >
                      Visual Aid
                    </Button>
                  )}
                  {session?.demoResources?.ppt && (
                    <Button
                      className={classes.BtnCls}
                      startIcon={
                        <LaunchOutlinedIcon
                          className={classes.icon}
                          fontSize="medium"
                        />
                      }
                      onClick={() =>
                        handleOpenInNewTab(session?.demoResources?.ppt)
                      }
                    >
                      PPT
                    </Button>
                  )}
                  {session?.demoResources?.curriculum && (
                    <Button
                      className={classes.BtnCls}
                      startIcon={
                        <LaunchOutlinedIcon
                          className={classes.icon}
                          fontSize="medium"
                        />
                      }
                      onClick={() =>
                        handleOpenInNewTab(session?.demoResources?.curriculum)
                      }
                    >
                      Curriculum
                    </Button>
                  )}
                  {showFeedbackPopup && (
                    <StudentHistoryPopup
                      open={showFeedbackPopup}
                      closeModal={closeFeedbackPopup}
                      studentId={studentId}
                      courseId={courseId}
                    />
                  )}
                  {!isDemo && (
                    <>
                      {historyData && historyData.length > 0 && (
                        <Button
                          className={classes.BtnCls}
                          startIcon={
                            <LaunchOutlinedIcon
                              className={classes.icon}
                              fontSize="medium"
                            />
                          }
                          onClick={handleFeedbackClick}
                        >
                          Feedback
                        </Button>
                      )}

                      {session.studentDetails.map((student, index) => (
                        <React.Fragment key={index}>
                          <Button
                            className={classes.BtnCls}
                            startIcon={
                              <LaunchOutlinedIcon
                                className={classes.icon}
                                fontSize="medium"
                              />
                            }
                            onClick={() => viewSPRHandler(index)}
                          >
                            SPR
                          </Button>
                        </React.Fragment>
                      ))}
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </CardContent>

      {/* Reschedule and Cancel Flow Modals */}
      <MentorEditAndReschedule
        open={editRescheduleOpen}
        onClose={handleEditRescheduleClose}
        initialClassData={{
          scheduleId: session?.scheduleId,
          studentId: session?.studentDetails?.[0]?.studentId,
          startDateTime: session?.sessionIndiaStartTime,
        }}
      />
    </Card>
  );
};

export default UpcomingSessionCard;
